// extracted by mini-css-extract-plugin
module.exports = {"panel":"index_panel__YTLx1","title":"index_title__2Qou9","panel_tabs":"index_panel_tabs__2IJQ-","controls":"index_controls__2Z2_s","prop_item":"index_prop_item__2K8yl"};